import React from 'react';
export const CookiePolicy = () => {
  return <div className="pt-20" data-id="element-1285">
      <section className="py-16 bg-secondary/5" data-id="element-1286">
        <div className="container mx-auto px-4" data-id="element-1287">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-1288">
            Cookie Policy
          </h1>
          <p className="text-center text-secondary" data-id="element-1289">Last updated: 19|08|2025</p>
        </div>
      </section>
      <section className="py-16" data-id="element-1290">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-1291">
          <div className="prose prose-lg max-w-none" data-id="element-1292">
            <p data-id="element-1293">
              The Networking Salon ("we," "our," or "us") uses cookies and
              similar technologies on our website to improve your browsing
              experience, analyze traffic, and provide relevant content. This
              Cookie Policy explains what cookies are, how we use them, and your
              choices.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-1294">
              1. What Are Cookies?
            </h2>
            <p data-id="element-1295">
              Cookies are small text files stored on your device when you visit
              a website. They help websites recognize your device, remember
              preferences, and improve functionality.
            </p>
            <p data-id="element-1296">Cookies may be:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-1297">
              <li data-id="element-1298">
                <strong data-id="element-1299">Session Cookies:</strong> Temporary, deleted when you
                close your browser.
              </li>
              <li data-id="element-1300">
                <strong data-id="element-1301">Persistent Cookies:</strong> Stay on your device until
                deleted or they expire.
              </li>
              <li data-id="element-1302">
                <strong data-id="element-1303">First-Party Cookies:</strong> Placed by our website.
              </li>
              <li data-id="element-1304">
                <strong data-id="element-1305">Third-Party Cookies:</strong> Placed by external
                services (e.g., Google Analytics, social media).
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-1306">
              2. How We Use Cookies
            </h2>
            <p data-id="element-1307">We use cookies to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-1308">
              <li data-id="element-1309">
                <strong data-id="element-1310">Essential:</strong> Ensure our website functions
                properly (e.g., navigation, forms).
              </li>
              <li data-id="element-1311">
                <strong data-id="element-1312">Analytics:</strong> Understand how visitors use our site
                to improve performance (e.g., Google Analytics).
              </li>
              <li data-id="element-1313">
                <strong data-id="element-1314">Preferences:</strong> Remember your settings (e.g.,
                language, event selections).
              </li>
              <li data-id="element-1315">
                <strong data-id="element-1316">Marketing:</strong> Deliver relevant promotions and
                measure the effectiveness of campaigns.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-1317">
              3. Third-Party Cookies
            </h2>
            <p data-id="element-1318">We may use trusted third-party services, including:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-1319">
              <li data-id="element-1320">Google Analytics for insights on website usage.</li>
              <li data-id="element-1321">
                Social Media Plugins (e.g., LinkedIn, Instagram) for sharing and
                engagement.
              </li>
            </ul>
            <p data-id="element-1322">
              These providers may set cookies according to their own privacy
              policies.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-1323">4. Your Choices</h2>
            <p data-id="element-1324">You can manage or disable cookies by:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-1325">
              <li data-id="element-1326">
                Adjusting your browser settings to block or delete cookies.
              </li>
              <li data-id="element-1327">
                Opting out of analytics/advertising cookies where applicable.
              </li>
            </ul>
            <p data-id="element-1328">
              Please note: disabling cookies may affect website functionality.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-1329">
              5. Updates to This Policy
            </h2>
            <p data-id="element-1330">
              We may update this Cookie Policy to reflect changes in technology,
              legal requirements, or our practices. Updates will be posted on
              this page with a new "last updated" date.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-1331">6. Contact Us</h2>
            <p data-id="element-1332">For questions about our use of cookies, please contact us:</p>
            <p data-id="element-1333">
              📧 Email:{' '}
              <a href="mailto:info@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-1334">
                info@thenetworkingsalon.live
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>;
};